module.exports = __webpack_public_path__ + "img/nomessage.6d64c3f8.png";